/* eslint-disable max-len */
import { memo } from 'react';

import classes from './loader.module.scss';

interface ILoaderProps {
  fill?: string;
}

function Loader({ fill }: ILoaderProps) {
  return (
    <svg
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classes.spinner}
    >
      <path
        d="M18.9974 4.10426C15.0468 4.10426 11.258 5.67363 8.46445 8.46714C5.67094 11.2607 4.10156 15.0495 4.10156 19.0001C4.10156 19.4559 3.92048 19.8931 3.59815 20.2154C3.27582 20.5378 2.83865 20.7188 2.38281 20.7188C1.92697 20.7188 1.4898 20.5378 1.16747 20.2154C0.845144 19.8931 0.664063 19.4559 0.664062 19.0001C0.664063 15.3741 1.73929 11.8295 3.75379 8.81463C5.76828 5.79973 8.63155 3.4499 11.9815 2.0623C15.3315 0.674692 19.0177 0.311631 22.574 1.01903C26.1304 1.72642 29.3971 3.4725 31.961 6.03646C34.525 8.60043 36.2711 11.8671 36.9785 15.4234C37.6859 18.9797 37.3228 22.666 35.9352 26.0159C34.5476 29.3659 32.1977 32.2292 29.1828 34.2437C26.1679 36.2582 22.6234 37.3334 18.9974 37.3334C18.5416 37.3334 18.1044 37.1523 17.7821 36.83C17.4597 36.5077 17.2786 36.0705 17.2786 35.6147C17.2786 35.1588 17.4597 34.7217 17.7821 34.3993C18.1044 34.077 18.5416 33.8959 18.9974 33.8959C22.948 33.8959 26.7368 32.3265 29.5303 29.533C32.3238 26.7395 33.8932 22.9507 33.8932 19.0001C33.8932 15.0495 32.3238 11.2607 29.5303 8.46714C26.7368 5.67363 22.948 4.10426 18.9974 4.10426Z"
        fill={fill || '#00FB68'}
      />
    </svg>
  );
}

export default memo(Loader);
